import * as z from "zod/v4";

const GetPromptsByCategoryInput_ = z.object({ limit: z.number().nullish() });

const CategoryCount_ = z.object({ category: z.string(), count: z.number() });

export const getPromptsByCategory = {
  name: "getPromptsByCategory" as const,
  input: GetPromptsByCategoryInput_,
  output: z.object({ categories: z.array(CategoryCount_) }),
};
